import React from "react";
import { useSelector } from "react-redux";
import { Auth0Provider, Auth0ProviderOptions } from "@auth0/auth0-react";

import { getClientInfo } from "../redux/reducers/appReducer";

const Auth0ProviderCustom: React.FC<React.PropsWithChildren> = ({ children }) => {
  const onRedirectCallback = (appState) => {
    window.history.pushState(
      "",
      "",
      appState && appState.returnTo ? appState.returnTo : window.location.pathname,
    );
  };

  const state = useSelector((state) => getClientInfo(state));

  // Please see https://auth0.github.io/auth0-react/interfaces/auth0provideroptions.html
  // for a full list of the available properties on the provider

  const providerConfig: Auth0ProviderOptions = {
    domain: state.authUrl,
    clientId: state.clientId,
    authorizationParams: {
      audience: state.apiName,
      redirect_uri: window.location.origin,
      scope: state.scope,
    },
    onRedirectCallback,
    // Keep the tokens between visits. With the in-memory default every reload signed in again through a hidden
    // Auth0 iframe, and browsers that block third-party cookies (Safari, Firefox) sent the user through a full
    // redirect to Auth0 and back instead.
    cacheLocation: "localstorage",
    useRefreshTokens: true,
    // auth0-react 1.x fell back to a silent iframe login when no refresh token was cached; keep doing that so
    // sessions started before the upgrade carry on.
    useRefreshTokensFallback: true,
  };

  return <Auth0Provider {...providerConfig}>{children}</Auth0Provider>;
};

export default Auth0ProviderCustom;
